<template>
    <app-button native-type="button" type="info" class="text-white" :class="{'float-right': right, 'float-left': left}" @click="$router.go(-1)" small>
        {{ $t('Back') }}
    </app-button>
</template>

<script>
export default {
    name: 'AppBackButton',
    props: {
        right: Boolean,
        left: Boolean
    }
};
</script>
